import React from "react";
import { useState } from "react";
import { Link } from "react-router-dom";
const Login = () => {
  //
  const [user, setUser] = useState({
    name: "",
    pass: "",
  });
  //
  const changed = (item) => {
    setUser({ ...user, [item.target.name]: item.target.value });
  };
  //
  const clicked = () => {
    const _username = localStorage.getItem(user.name);
    const username = JSON.parse(_username);
    const passs = username.pass;
    if (user.pass == passs) {
      window.location.replace("/سبد خرید/");
    } else {
      alert("اطلاعات وارد شده درست نمیباشد");
    }
  };

  return (
    <>
      <div
        style={{ display: "grid", textAlign: "center", justifyItems: "center" }}
      >
        <h1
          style={{
            marginBottom: "25px",
            borderStyle: "dotted",
            padding: "10px",
            borderRadius: "10px",
          }}
        >
          ورود
        </h1>
        <input
          type="text"
          placeholder="نام کاربری خود را وارد کنید "
          value={user.name}
          onChange={changed}
          name="name"
          style={{
            fontSize: "20px",
            marginBottom: "20px",
            borderRadius: "10px",
            padding: "10px",
          }}
        />
        <input
          type="password"
          placeholder="رمز عبور خود را وارد کنید "
          value={user.pass}
          onChange={changed}
          name="pass"
          style={{
            fontSize: "20px",
            marginBottom: "20px",
            borderRadius: "10px",
            padding: "10px",
          }}
        />
        <button
          onClick={clicked}
          style={{
            borderRadius: "30px",
            width: "100px",
            marginTop: "25px",
            fontSize: "30px",
          }}
        >
          ورود
        </button>
        <Link to="/ثبت نام-ورود/">
          <button
            style={{
              borderRadius: "30px",
              width: "100px",
              marginTop: "25px",
              fontSize: "30px",
            }}
          >
            ثبت نام
          </button>
        </Link>
      </div>
    </>
  );
};

export default Login;
